import { useState } from "react";
import { useSelector } from "react-redux";
import today from "../../../Artifacts/Todaysretail.png";
import StockMtd from "../../../Artifacts/offtakemtd.png";
import total from "../../../Artifacts/TotalRetail.png";
import { PriKPI } from "../../../Components/KPI/PriKPI";
import { useQuery } from "@tanstack/react-query";
import { TbFilterDown } from "react-icons/tb";
import StockFilter from "../../../Components/Filters/StockFilter";
import { mtd_stock, today_stock, total_stock } from "./ApiStock";
import { StockTableDetailed } from "../StockDetail/StockTableDetailed";

export const StockKpi = () => {
  const { data, submitted } = useSelector((state) => state.filtersStock);
  const [isFormVisible, setFormVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: mtdStock } = useQuery({
    queryKey: ["mtd_Stock", submitted],
    queryFn: () => mtd_stock(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: todayStock } = useQuery({
    queryKey: ["today_Stock", submitted],
    queryFn: () => today_stock(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: totalStock } = useQuery({
    queryKey: ["total_Stock", submitted],
    queryFn: () => total_stock(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });
  const toggleForm = () => {
    setFormVisible(!isFormVisible);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="flex flex-col gap-2 ">
      {isFormVisible && (
        <StockFilter
          isFormVisible={isFormVisible}
          setFormVisible={setFormVisible}
        />
      )}
      <div className="flex gap-2  md:flex-row flex-col-reverse">
        <section className="md:grid block grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-3 md:w-[95%] w-full">
          <PriKPI
            Image={StockMtd}
            Alt={"MTD Stock"}
            ColorDark={"bg-gradient-to-b from-[#3CD0C0] to-[#129BD2]"}
            Title={"MTD Stock"}
            Value={mtdStock || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
            ImageSize={"w-12 h-12"}
          />
          <PriKPI
            Image={today}
            Alt={"YTD Stock"}
            ColorDark={"bg-gradient-to-b from-[#FFE700] to-[#F9A526]"}
            Title={"YTD Stock"}
            Value={todayStock || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
            ImageSize={"w-12 h-12"}
          />
          <PriKPI
            Image={total}
            Alt={"Total Stock"}
            ColorDark={"bg-gradient-to-b from-[#EF6AE9] to-[#8463FA]"}
            Title={"Total Stock"}
            Value={totalStock || 0}
            Padding={"p-2 md:mt-0 sm:mt-5"}
            ImageSize={"w-14 h-12"}
            onclick={openModal}
            title={"Click to View Detailed Summary"}
            handPosition={" right-[15px] top-[17px] "}
          />
        </section>
        <div
          className="w-full lg:w-[5%] rounded-lg p-2 bg-gradient-to-b from-rose-300 to-orange-200 flex justify-center items-center transition duration-300 ease-in-out transform hover:scale-105 cursor-pointer "
          onClick={toggleForm}
        >
          <button title="Click to Apply Filters">
            <TbFilterDown className="w-7 h-7 text-[#2A5775]" />
          </button>
        </div>
      </div>
      {isModalOpen && (
        <StockTableDetailed closeModal={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};
